export default ({ string }, context) => {
	return ({
		type: "text",
		value: string,
	});
};
